import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader"
import CardIcon from "../../components/Card/CardIcon";
import CardFooter from "../../components/Card/CardFooter.jsx";
import dashboardStyle from "./dashboardStyle";
import Order from '../../assets/img/orders.png'
import warning from '../../assets/img/overdue.png';
import onhold from '../../assets/img/hold.png';
import { Link } from 'react-router-dom'

function DailyCardTiles(props) {
  const { classes } = props;

  return (
    <div style={{ marginTop: "5%" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4} lg={3}>
          <Card className={classes.card}>
            <CardHeader color="info" stats icon>
            <CardIcon style={{ backgroundColor: "#D81B60", width: "82px", height: "83px", marginTop: "-30px", borderRadius: "3px" }}>
              <span>
                <img style={{ height: "33px", marginLeft: "22px", marginTop: "25px", marginRight:"22px" }} src={Order} alt="" />
              </span>
            </CardIcon>
              <Link to="/Openorder">
                <p  className={classes.cardCategory}>ORDERS TODAY</p>
              </Link>
              <h3 className={classes.cardTitle}>
                {props.today || 0}
              </h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4} lg={3}>
          <Card className={classes.card1}>
            <CardHeader color="success" stats icon>
              <CardIcon style={{ backgroundColor: "#43A047 ", width: "82px", height: "83px", marginTop: "-30px", borderRadius: "3px" }}>
                <span>
                  <img style={{ height: "33px", marginLeft: "22px", marginTop: "25px",marginRight:"24px" }} src={onhold} alt="" />
                </span>
              </CardIcon>
                <Link to="/Openorder">
                  <p className={classes.cardCategory}>ORDERS DUE TODAY</p>
                </Link>
                <h3 className={classes.cardTitle}>
                  {props.due || 0}
                </h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4} lg={3}>
          <Card className={classes.card2}>
            <CardHeader color="warning" stats icon>
              <CardIcon style={{ backgroundColor: "#FB8C00", width: "82px", height: "83px", marginTop: "-30px", borderRadius: "3px" }}>
                <span>
                  <img style={{ height: "33px", marginLeft: "22px", marginTop: "25px",marginRight:"20px" }} src={warning} alt="" />
                </span>
              </CardIcon>
                <Link to="/Completedorder">
                  <p className={classes.cardCategory}>ORDERS COMPLETED TODAY</p>
                </Link>
                <h3 className={classes.cardTitle}>
                  {props.completed || 0}
                </h3>
              </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(dashboardStyle)(DailyCardTiles);
